import { render, staticRenderFns } from "./MiniSidebar.vue?vue&type=template&id=bdac3d7c"
import script from "./MiniSidebar.vue?vue&type=script&lang=js"
export * from "./MiniSidebar.vue?vue&type=script&lang=js"
import style0 from "./MiniSidebar.vue?vue&type=style&index=0&id=bdac3d7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports